import {createReducer, on} from '@ngrx/store';
import {
  clearDeleteManyProductionInstancesState,
  deleteManyProductionInstances,
  deleteManyProductionInstancesFailure,
  deleteManyProductionInstancesSuccess
} from './production-instance.delete-many.actions';


export interface State {
  record: null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const deleteManyProductionInstancesReducer = createReducer(
  initialState,

  on(deleteManyProductionInstances, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(deleteManyProductionInstancesSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(deleteManyProductionInstancesFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearDeleteManyProductionInstancesState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

